import { TextLabel } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const AdesaoContratoVisualizacao = ({ adesao, getCurrency, getDescricaoFormaCobranca }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextLabel
          id="adesao.servico"
          label="Serviço"
          value={
            adesao?.servico?.codigo
              ? `${adesao?.servico?.codigo} - ${adesao?.servico?.descricao}`
              : adesao?.servico?.descricao
          }
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel
          id="adesao.categoria"
          label="Categoria"
          value={`${adesao?.categoria?.indice} - ${adesao?.categoria?.nome}`}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel
          id="adesao.subtotal"
          label="Valor bruto (R$)"
          value={adesao?.subtotal && getCurrency(adesao.subtotal)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel
          id="adesao.formaCobranca"
          label="Forma de recebimento"
          value={getDescricaoFormaCobranca(adesao?.formaCobranca)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextLabel
          id="adesao.dataVencimento"
          label="Data do vencimento"
          value={adesao?.dataVencimento && moment(adesao.dataVencimento).format('DD/MM/YYYY')}
        />
      </Grid>
    </Grid>
  );
};

export default AdesaoContratoVisualizacao;
